module.exports = __webpack_public_path__ + "static/media/view driver.4353e64b.svg";